import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface GlobalErrorState {
  isOpen: boolean;
  message: string;
  statusCode: number | null;
}

const initialState: GlobalErrorState = {
  isOpen: false,
  message: '',
  statusCode: null,
};

const globalErrorSlice = createSlice({
  name: 'globalError',
  initialState,
  reducers: {
    /**
     * Show error dialog with message and optional HTTP status code.
     * Called by unhandledrejection listener when an uncaught error occurs.
     * statusCode is null for non-API errors (network errors, parsing errors, etc).
     */
    showError: (state, action: PayloadAction<{ message: string; statusCode: number | null }>) => {
      state.isOpen = true;
      state.message = action.payload.message;
      state.statusCode = action.payload.statusCode;
    },

    /**
     * Close error dialog when user clicks "Dismiss" or after reload.
     */
    closeError: (state) => {
      state.isOpen = false;
      state.message = '';
      state.statusCode = null;
    },
  },
});

export const { showError, closeError } = globalErrorSlice.actions;
export default globalErrorSlice.reducer;
